<template>
  <div class="container">
    <!-- 输入框和按钮部分 -->
    <div class="input-section">

      <input id="shopName" type="text" v-model="shopName" :placeholder="$t('店铺名称')" />
    </div>

    <button v-if="!userInfo.shopSupportTime || !isToday(userInfo.shopSupportTime)" @click="support" class="help-button" style="color: red">{{$t('立即助力')}}</button>
    <button v-else class="help-button" style="color: #666">{{$t('今日已助力')}}</button>

    <!-- 上方带钩子的横线 -->
    <div class="line-with-hooks" />

    <!-- 已累计助力文本 -->
    <div class="header">
      <span>{{$t('已累计助力')}}</span>
    </div>

    <!-- 数字显示 -->
    <div class="counter">
      <div class="digit" v-for="(num, index) in digits" :key="index">
        <span class="flip">{{ num }}</span>
      </div>
    </div>

    <!-- 描述文字 -->
    <div class="description">
      <p>{{$t('助力提示')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      token: null,
      shopName: '',  // 店铺名称
    };
  },
  computed: {
    // 计算数字显示，确保根据 shopSupportCount 生成 4 位数字
    digits() {
      let count = String(this.userInfo.shopSupportCount||0).padStart(4, '0');
      return count.split('');
    }
  },
  created() {
    this.$store.dispatch("user/getUserInfo");
    this.getToken()
  },
  methods: {
    async getToken() {
      this.token = (await this.$store.dispatch("common/getToken")).data;
    },
    // 判断 shopSupportTime 是否是今天
    isToday(shopSupportTime) {
      const today = new Date();
      const shopDate = new Date(shopSupportTime);

      // 比较年月日部分
      return today.getFullYear() === shopDate.getFullYear() &&
          today.getMonth() === shopDate.getMonth() &&
          today.getDate() === shopDate.getDate();
    },
    async support() {
      this.$post('/userShopSupport/support', {shopName:this.shopName,"X-IDEMPOTENT-TOKEN":this.token}).then(res => {
        this.$toast.success(this.$t("Commit_Success"));
      }).finally(e => {
        this.getToken()
        this.$store.dispatch("user/getUserInfo");
      })
    }
  },
};
</script>

<style scoped>
/* 容器样式 */
.container {
  width: 300px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
}

/* 输入框和按钮部分 */
.input-section {
  margin-bottom: 15px;
}

label {
  font-size: 14px;
  color: #333;
}

input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ddd;
  margin-top: 5px;
}

.help-button {
  width: 100%;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 16px;
  margin-top: 10px;
  cursor: pointer;
}

.help-button:hover {
  background-color: #e0e0e0;
}

/* 上方带钩子的横线样式 */
.line-with-hooks {
  position: relative;
  width: 100%;
  height: 20px;
  background-color: transparent;
  margin-bottom: 20px;
}

/* 已累计助力文本样式 */
.header {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
}

/* 数字显示样式 */
.counter {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.digit {
  width: 36px;
  height: 48px;
  background-color: #f1f1f1;
  border-radius: 6px;
  margin: 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: #d93c30;
  position: relative;
}

.flip {
  display: block;
  transition: transform 0.3s ease;
}

.description {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}
</style>
